export default __webpack_public_path__ + "images/8bbe4a7e9ec4978c9889f98a289c4eac.png";